import { Field } from 'formik';
import React from 'react';
import { AddressInput } from 'src/features/common/components/address-input/address-input';

export function AddressStep() {
  return (
    <article className="flex flex-col md:w-112">
      <h1 className="text-2xl font-medium text-center text-gray-700 md:text-4xl py-7">
        Add delivery address
      </h1>
      <section className="flex-1 overflow-y-auto">
        <div className="overflow-y-auto h-full pr-[5px] pl-[5px]">
          <Field
            name="address"
            component={AddressInput}
            useFormLayout={true}
            titleLowerCase="delivery address"
            brokerLogin={true}
            isLightMode={true}
            id="address-input"
          />
        </div>
      </section>
    </article>
  );
}
